import Vue from 'vue'

//import Sentry from '@utils/Sentry';
import router from './routers/calendar';
import store from './store/store';
import CalendarApp from "@/views/calendar/CalendarApp";

import * as Sentry from '@sentry/vue';
import sentryConfig from '@/config/Sentry';
Sentry.init({
  Vue: Vue,
  ...sentryConfig
});

Vue.config.productionTip = false
Vue.config.performance = true

new Vue({
  render: h => h(CalendarApp),
  router,
  store,
}).$mount('#calendarApp')
